import classNames from "classnames";
import { twMerge } from "tailwind-merge";

export function cn(...classes) {
    return twMerge(classNames(...classes));
  };